import { call, put, takeLatest, } from 'redux-saga/effects'
import { Urls } from 'src/common/urls'
import * as Actions from './action'
import * as ActionTypes from './actionTypes'
import { NetworkingProvider } from 'src/features/Security/networking/networkingProvider'
import { ActivityLogtRecordsFilters } from '../models/activityLog'
import { getErrorFromResponse } from 'src/features/Security/networking/util'

function* getCompanyByIdApi(action: Actions.GetCompanyByIdAction) {
    try {
        const response = yield call(NetworkingProvider.getInstance().getControlInterface().get, Urls.BACKEND.COMPANY.GET_BY_ID(action.companyId))
        yield put(Actions.getCompanyByIdSuccess(response.data))
    } catch (err) {
        yield put(Actions.getCompanyByIdError(err));
    }
}

function* updateCompanyDataApi(action: Actions.UpdateCompanyDataAction) {
    try {
        const response = yield call(NetworkingProvider.getInstance().getControlInterface().post, Urls.BACKEND.COMPANY.UPSERT, action.company)
        yield put(Actions.updateCompanyDataSuccess(response.data))
    } catch (err) {
        yield put(Actions.updateCompanyDataError(err));
    }
}

const buildQueryString = (filters?: ActivityLogtRecordsFilters) => {
    const filtersList: string[] = []
    if (filters?.dateFrom && filters?.dateTo) {
        filtersList.push(`dateFrom=${filters.dateFrom}`)
        filtersList.push(`dateTo=${filters.dateTo}`)
    }
    if (filters?.ref) {
        filtersList.push(`ref=${filters.ref}`)
    }
    if (filters?.type) {
        filtersList.push(`type=${filters.type}`)
    }

    return filtersList.length > 0
        ? `?${filtersList.join('&')}`
        : ``
}

function* getActivityLogRecordsApi(action: Actions.GetActivityLogRecordsAction) {
    try {
        const response = yield call(NetworkingProvider.getInstance().getControlInterface().get, Urls.BACKEND.ACTIVITY_LOG.GET_RECORDS(buildQueryString(action.filters)))
        yield put(Actions.getActivityLogRecordsSuccess(response.data))
    } catch (err) {
        yield put(Actions.getActivityLogRecordsError(getErrorFromResponse(err)));
    }
}

export default function* commonSagas() {
    yield takeLatest(ActionTypes.GET_COMPANY_API, getCompanyByIdApi)
    yield takeLatest(ActionTypes.UPDATE_COMPANY_DATA_API, updateCompanyDataApi)
    yield takeLatest(ActionTypes.GET_ACTIVITY_LOG_RECORDS_API, getActivityLogRecordsApi)
}